import { render, staticRenderFns } from "./KohlersRealm.vue?vue&type=template&id=2466fb13&scoped=true&"
import script from "./KohlersRealm.vue?vue&type=script&lang=js&"
export * from "./KohlersRealm.vue?vue&type=script&lang=js&"
import style0 from "./KohlersRealm.vue?vue&type=style&index=0&id=2466fb13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466fb13",
  null
  
)

export default component.exports